/* eslint-disable @typescript-eslint/no-this-alias */
import styles from "./matheditor.module.scss";
import React from "react";

import MathEditor from "./MathEditor";
import LoadingIndicator from "./../LoadingIndicator";
import { Editor } from "@tinymce/tinymce-react";
import { generateId, loadScript } from "../_util/common";
import PropTypes from "prop-types";
const $ = window.jQuery;
window.$ = window.jQuery;

class TextEditor extends React.Component {
  constructor() {
    super();
    this.state = {
      editorIsOpen: false,
      content: undefined,
      contentId: undefined,
      editorLoader: true,
      isClearPlaceholder: true,
    };
    this.editor = undefined;
    this.handleEditorLoad = this.handleEditorLoad.bind(this);
  }

  setEditorOpen = (value, contentId = undefined, content = "") => {
    let math = "";
    if (content) {
      math = JSON.parse(content.getAttribute("mathdata"));
    }

    this.setState({
      editorIsOpen: value,
      content: math,
      contentId,
    });
  };

  handleEditorChange = (content) => {
    // Replace toggleMathEditor_${this.props.id} with toggleMathEditor and touchToggleMathEditor_${this.props.id} with touchToggleMathEditor for consistency
    content = content.replace(/(toggleMathEditor)[^("']+/g, '$1');
    content = content.replace(/(touchToggleMathEditor)[^("']+/g, '$1');
    this.props.onChange(content);
  };

  setEditorInstance = () => {
    if (typeof this.props.setEditorInstance === "function") {
      this.props.setEditorInstance(this.editor);
    }
  };

  getExpressionsByID(html) {
    let expressions = {};
    const jhtml = $(`<div>${html}</div>`);
    jhtml.find(`.pmml`).each((idx, elem) => {
      const pmmlClsName = window
        .$(elem)
        .attr("class")
        .split(/\s+/)
        .find((clstr) => clstr.match(/pmml-key/));
      expressions[pmmlClsName] = elem.innerHTML;
    });
    return expressions;
  }

  replaceExpressions(expressions, html) {
    const jhtml = $(`<div>${html}</div>`);
    jhtml.find(`.pmml`).each((idx, elem) => {
      const pmmlClsName = window
        .$(elem)
        .attr("class")
        .split(/\s+/)
        .find((clstr) => clstr.match(/pmml-key/));
      if (expressions[pmmlClsName]) {
        window.$(elem).html(expressions[pmmlClsName]);
      }
    });
    return jhtml.html();
  }

  disableContentEditable = (str) => {
    return str
      .replace(
        new RegExp(
          '<div class="pmml mceNonEditable ppbMathElement pmml-key-',
          "g"
        ),
        '<div contenteditable="false" class="pmml mceNonEditable ppbMathElement pmml-key-'
      )
      .replace(
        new RegExp('class="mce-item pmml-child mceNonEditable pmml-key-', "g"),
        'contenteditable="false" class="mce-item pmml-child mceNonEditable pmml-key-'
      );
  };

  setMathContent = (pmml, cmml, svg, mlId, oldMlId) => {
    // cmml = cmml.replace(/<\/body>/gi,"").replace(/<body>/gi,"")
    const finalPMML = `<div class="pmml mceNonEditable ppbMathElement pmml-key-${mlId}">
            <div onclick="window.parent.$.data(parent.document.body, 'modify','${mlId}');
            window.parent.toggleMathEditor(true, '${mlId}', this);"
            ontouchstart="window.parent.$.data(parent.document.body, 'modify','${mlId}'); window.parent.touchToggleMathEditor(event, true, '${mlId}', this);"
            class="mce-item pmml-child mceNonEditable pmml-key-${mlId}" mathdata='${JSON.stringify(
      cmml
    )}'  pmmldata='${JSON.stringify(svg)}'
    >${svg}</div>
            </div> `;

    const fhtml = finalPMML;
    if (oldMlId) {
      window
        .$(this.editor.iframeElement)
        .contents()
        .find("body")
        .find(`.pmml.pmml-key-${oldMlId}`)
        .replaceWith(this.disableContentEditable(fhtml));
      this.editor.setDirty(true);
      this.editor.fire("change");
      if (this.editor.getDoc().defaultView.MathJax.typeset) {
        this.editor.getDoc().defaultView.MathJax.typeset();
      }
      this.editor.execCommand("mceCleanup", false, fhtml);
    } else {
      this.editor.execCommand("mceInsertContent", false, fhtml);
    }
  };

  onContentDeleteMathEditor = (oldMlId) => {
    if (oldMlId) {
      window
        .$(this.editor.iframeElement)
        .contents()
        .find("body")
        .find(`.pmml.pmml-key-${oldMlId}`)
        .replaceWith("");
      this.editor.setDirty(true);
      this.editor.fire("change");
      this.editor.execCommand("mceCleanup", false, "");
    }
  };

  componentDidMount() {
    const dynamicToggleMathEditorMethod = `toggleMathEditor_${this.props.id}`
    const dynamicTouchToggleMathEditorMethod = `touchToggleMathEditor_${this.props.id}`
    window[dynamicToggleMathEditorMethod] = this.setEditorOpen;
    window[dynamicTouchToggleMathEditorMethod] = (e, value, contentId, content) => {
      e.preventDefault();
      this.setEditorOpen(value, contentId, content);
    };

    if (this.props.loader) {
      this.setState({
        editorLoader: false,
      });
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.initialContent !== prevProps.initialContent) {
      this.editor.setContent(this.props.initialContent);
    }
  }

  getMathMl = (content, editorId) => {
    let parser = new DOMParser();
    var contentElement = document.createElement("div");
    //remove no script
    content = content.replace(/<noscript[\s\S]*?>[\s\S]*?<\/noscript>/gi, "");
    contentElement.innerHTML = content;
    var header = document.createElement("head");
    if (contentElement.getElementsByTagName("head").length === 0) {
      contentElement.prepend(header);
    }
    contentElement.querySelectorAll("link").forEach((e) => {
      contentElement.getElementsByTagName("head")[0].appendChild(e);
    });
    let parsedHtml = parser.parseFromString(
      contentElement.innerHTML,
      "text/html"
    );
    const mathElements = parsedHtml.querySelectorAll(".pmml-child");
    mathElements.forEach(function (element) {
      // Replace toggleMathEditor with toggleMathEditor_${this.props.id} and touchToggleMathEditor with touchToggleMathEditor_${this.props.id} for opening the math editor
      let updatedOuterHtml = element.outerHTML;
      updatedOuterHtml = updatedOuterHtml.replace(/(toggleMathEditor)/g, `$1_${editorId}`).replace(/(toggleMathEditor)[^("']+/g, `$1_${editorId}`);
      updatedOuterHtml = updatedOuterHtml.replace(/(touchToggleMathEditor)/g, `$1_${editorId}`).replace(/(touchToggleMathEditor)[^("']+/g, `$1_${editorId}`);

      element.outerHTML = updatedOuterHtml; 
      const originalMathContent = JSON.parse(element.getAttribute("pmmldata"));
      const mathElement = parsedHtml.querySelector(
        `.pmml-child.${element.classList[3]}`
      );
      mathElement.innerHTML = originalMathContent;
    });
    return `${parsedHtml.head.outerHTML}${parsedHtml.body.outerHTML}`;
  };

  onBeforeSetContent = (content) => {
    content.content = this.getMathMl(content.content, this.props.id);
  };

  customMediaResolver = (data, resolve /*, reject*/) => {
    let embedHtml = "";
    let iFrame_1 = '<iframe src="https://www.youtube.com/embed/';
    let iFrame_2 = '" width="400" height="200" ></iframe>';
    if (data.url.indexOf(data.url) !== -1) {
      if (data.url.includes("https://youtu.be")) {
        embedHtml = iFrame_1 + data.url.split("youtu.be/", 2).pop() + iFrame_2;
        resolve({ html: embedHtml });
      } else if (data.url.includes("https://www.youtube")) {
        embedHtml =
          iFrame_1 +
          data.url.split("youtube.com/watch?v=", 2).pop().replace("&", "?") +
          iFrame_2;
        resolve({ html: embedHtml });
      } else {
        embedHtml = '<iframe src="' + data.url + iFrame_2;
        resolve({ html: embedHtml });
      }
    } else {
      resolve({ html: "" });
    }
  };

  handleEditorLoad() {
    loadScript(
      "Mathjax lib",
      "https://learningapps-ui.pearson.com/b0/lass-ui-cdn-libs/v1.2.0/matheditor/js/mathjax.js",
      () => {
        this.setState({
          editorLoader: true,
        });
      }
    );
    loadScript(
      "Jquery lib",
      "https://ajax.googleapis.com/ajax/libs/jquery/3.3.1/jquery.min.js",
      () => {}
    );
  }

  handleEditorInit(editor) {
    // this fix is specific for OV - LAF-6982
    const specificSelector = ".ov-footer";
    const specificElement = document.querySelector(specificSelector);
    if (specificElement) {
      const reactModalContent = document.querySelector(".ReactModal__Content");
      const originalTransform = reactModalContent.style.transform;

      editor.on("FullscreenStateChanged", (event) => {
        if (event.state) {
          reactModalContent.style.transform = "none";
        } else {
          reactModalContent.style.transform = originalTransform;
        }
      });
    }
  }

  render() {
    const { editorIsOpen, content, contentId, editorLoader } = this.state;
    const { contentStyle, quickbarsSelectionToolbar } = this.props;
    const that = this;
    return (
      <>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <LoadingIndicator
            strokeWidth="5"
            color="#047a9c"
            width="50px"
            height="50px"
            dashDuration="2s"
            rotateDuration="2s"
            isHidden={editorLoader}
            isLoading
          />
        </div>
        <div
          className={styles.matheditor_container}
          style={!editorLoader ? { display: "none" } : {}}
        >
          <div id="mathjax_rendering_sandbox" style={{ display: "none" }}></div>
          {this.props.mathEditor && (
            <MathEditor
              isOpen={editorIsOpen}
              content={content || ""}
              contentId={contentId}
              closeEditor={() => this.setEditorOpen(false)}
              setContent={(pmml, cmml, svg, mlId, oldMlId, mml) =>
                this.setMathContent(pmml, cmml, svg, mlId, oldMlId, mml)
              }
              onContentDeleteMathEditor={(oldMlId)=>{
                this.onContentDeleteMathEditor(oldMlId)
              }}
            />
          )}
          <Editor
            // apiKey={this.props.tinymceApiKey}
            tinymceScriptSrc="https://learningapps-ui.pearson.com/b0/lass-ui-cdn-libs/v1.2.0/tinymce/v5.10.7/js/tinymce/tinymce.min.js"
            initialValue={this.props.initialContent}
            onInit={this.handleEditorLoad}
            disabled={this.props.disabled}
            init={{
              automatic_uploads: false,
              convert_urls: false,
              ie7_compat: false,
              force_br_newlines: false,
              force_p_newlines: false,
              default_link_target: "_blank",
              link_context_toolbar: true,
              link_assume_external_targets: true,
              link_default_protocol: "https",
              link_title: false,
              a11y_advanced_options: true,
              init_instance_callback: (editor) => this.handleEditorInit(editor),
              //   fullpage_hide_in_source_view: false,
              custom_elements:
                "math,maction,maligngroup,malignmark,menclose,merror,mfenced,mfrac," +
                "mglyph,mi,mlabeledtr,mlongdiv,mmultiscripts,mn,mo,mover,mpadded,mphantom,mroot," +
                "mrow,ms,mscarries,mscarry,msgroup,msline,mspace,msqrt,msrow,mstack,mstyle,msub," +
                "msup,msubsup,mtable,mtd,mtext,mtr,munder,munderover,svg,mjx-container,defs,path,g,use,mjx-assistive-mml",
              extended_valid_elements: this.props.extended_valid_elements,
              valid_children: this.props.valid_children,
              content_style: contentStyle,
              content_css:
                "https://fonts.googleapis.com/css2?family=Great+Vibes&display=swap, https://fonts.googleapis.com/css2?family=UnifrakturMaguntia&display=swap, https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css,  https://fonts.googleapis.com/css2?family=Dancing+Script:wght@700&display=swap",
              plugins:
                "a11ychecker print preview paste searchreplace autolink autosave save directionality code visualblocks " +
                "visualchars fullscreen image link media template codesample table charmap hr pagebreak nonbreaking " +
                "anchor toc insertdatetime advlist lists wordcount imagetools textpattern noneditable help charmap quickbars emoticons",
              menubar: this.props.menubar,
              menu: {
                file: { title: "File", items: "preview | print " },
                edit: {
                  title: "Edit",
                  items:
                    "undo redo | cut copy paste pastetext | selectall | searchreplace",
                },
                view: {
                  title: "View",
                  items: "code | spellchecker | preview fullscreen",
                },
                insert: {
                  title: "Insert",
                  items: this.props.insertItems,
                },
                format: {
                  title: "Format",
                  items:
                    "bold italic underline strikethrough superscript subscript codeformat | formats blockformats fontformats fontsizes align lineheight | forecolor backcolor | removeformat",
                },
                tools: {
                  title: "Tools",
                  items: "spellchecker | code wordcount",
                },
                table: {
                  title: "Table",
                  items:
                    "inserttable | cell row column | tableprops deletetable",
                },
              },

              media_poster: false,
              media_alt_source: false,
              media_url_resolver: this.customMediaResolver,
              toolbar: this.props.toolbar,
              toolbar_sticky: false,
              height: this.props.height,
              quickbars_selection_toolbar: quickbarsSelectionToolbar,
              quickbars_insert_toolbar: false,
              noneditable_noneditable_class: "mceNonEditable",
              toolbar_mode: "sliding",
              contextmenu: "link image imagetools table",

              image_title: false,
              image_description: false,
              image_dimensions: false,
              images_upload_handler: this.props.imageUploadHandler,
              images_file_types: "jpg,png,jpeg",
              document_base_url: this.props.baseUrl,
              mobile: {
                toolbar_mode: "sliding",
                menubar: this.props.menubar,
              },
              fullscreen_native: true,
              schema: this.props.schema,
              valid_elements: this.props.valid_elements,
              sequential_focus_enabled: this.props.sequentialFocusEnabled,
              ...this.props.tinymce_extended_properties,
              setup: function (editor) {
                that.editor = editor;
                that.setEditorInstance();
                const sequentialFocusEnabled = editor.getParam('sequential_focus_enabled');

                //Editor configuration for placeholder
                const editorConfig = {
                  suppressUndo: true,
                  suppressRedo: true,
                };

                const getStringFromHtmlContent = (htmlContent) => {
                  let parser = new DOMParser();
                  let parsedDoc = parser.parseFromString(
                    htmlContent,
                    "text/html"
                  );
                  return parsedDoc.body.textContent;
                };


                // TinyMCE's own toolbar item selector
                // - .tox-tbtn that is NOT inside a .tox-split-button (individual buttons)
                // - .tox-split-button as a whole unit (the container, not inner buttons)
                // - .tox-toolbar-nav-js (toolbar text input fields)
                // Plus .tox-mbtn for menubar items.
                const TOOLBAR_ITEM_SELECTOR = [
                  '*:not(.tox-split-button) > .tox-tbtn:not([disabled])',
                  '.tox-split-button:not([disabled])',
                  '.tox-toolbar-nav-js:not([disabled])',
                  '.tox-mbtn'
                ].join(', ');

                // Toolbar buttons use `useNative: false` so they get aria-disabled
                // and the class tox-tbtn--disabled
                // Split buttons use aria-disabled + tox-tbtn--disabled.
                // Menubar buttons can have native disabled.
                const isItemDisabled = (el) =>
                  el.hasAttribute('disabled') ||
                  el.getAttribute('aria-disabled') === 'true' ||
                  el.classList.contains('tox-tbtn--disabled');

                // An element is visible if its height > 0 (in the layout).
                // Toolbar overflow drawer: when closed, TinyMCE sets
                // height:0px + overflow:hidden on .tox-toolbar__overflow, but child
                // buttons still report their intrinsic height via getBoundingClientRect().
                const isItemVisible = (el) => {
                  if (el.getBoundingClientRect().height <= 0) return false;
                  // Respects the toolbar overflow drawer open/closed state
                  const overflowContainer = el.closest('.tox-toolbar__overflow');
                  if (overflowContainer && !overflowContainer.classList.contains('tox-toolbar__overflow--open')) return false;

                  return true;
                };

                // All visible, enabled menubar and toolbar focusable items in DOM order
                const getMenuToolbarFocusables = () =>
                  Array.from(editor.getContainer().querySelectorAll(TOOLBAR_ITEM_SELECTOR))
                    .filter(el => !isItemDisabled(el) && isItemVisible(el));

                // Last visible, enabled focusable item in toolbar/menubar
                // Returns null when no menubar or toolbar exists.
                const getLastToolbarOrMenubarFocusable = () => {
                  const allBtns = getMenuToolbarFocusables();
                  return allBtns.length ? allBtns[allBtns.length - 1] : null;
                };

                // Helper to get statusbar focusables for editor container
                const getStatusbarItemsForContainer = (containerEl) => {
                  const statusbar = containerEl && containerEl.querySelector('.tox-statusbar');
                  const statusbarItems = statusbar ?
                    statusbar.querySelectorAll('.tox-statusbar__path-item, .tox-statusbar__wordcount, .tox-statusbar__resize-handle')
                    : [];
                  return statusbarItems;
                };

                // Resolve the container when the focus target is inside a different editor's container,
                // or when focus target is a textarea of a different editor
                const resolveEditorContainerForElement = (element, currentContainer) => {
                  if (!element) return null;
                  // Check if the focus target is inside another TextEditor container
                  const enclosingEditorContainer = element.closest &&
                    element.closest('[data-texteditor-sequential-focus]');
                  // If the focus target is inside another TextEditor container, return that container
                  if (enclosingEditorContainer && enclosingEditorContainer !== currentContainer)
                    return enclosingEditorContainer;
                  // If the focus target is a textarea of a text editor, return that editor's container
                  // textarea is a sibling of the editor container
                  if (element.tagName === 'TEXTAREA' && element.id) {
                    const nextSibling = element.nextElementSibling;
                    const prevSibling = element.previousElementSibling;
                    const siblingContainer = nextSibling || prevSibling;
                    if (siblingContainer && siblingContainer.getAttribute('data-texteditor-editor-id') === element.id) return siblingContainer;
                  }
                  
                  return null;
                };

                const getAllFocusableElements = () =>
                  document.querySelectorAll(
                    'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
                  );

                const focusPreviousElement = () => {
                  const originalTextarea = editor.getElement();
                  const container = editor.getContainer();

                  // Get all focusable elements on the page
                  const allFocusables = Array.from(getAllFocusableElements());

                  // Find the index of the editor's textarea in focusable elements
                  const textareaIndex = allFocusables.indexOf(originalTextarea);

                  // Focus the element immediately before the editor's textarea
                  if (textareaIndex > 0) {
                    const target = allFocusables[textareaIndex - 1];
                    // Reset flag as we are leaving editors internal navigation
                    editor._isNavigatingInternal = false;

                    // Check if the previous element is related to another TextEditor
                    const otherContainer = resolveEditorContainerForElement(target, container);
                    // If the previous element is related to another TextEditor,
                    // focus its entry point (menubar/statusbar/editor)
                    if (otherContainer && otherContainer !== container) {
                      const seqEnabled = otherContainer.getAttribute('data-texteditor-sequential-focus') === 'true';
                      // Sequential focus: focus last statusbar item (resize handle) when coming from below
                      if (seqEnabled) {
                        const statusbarItems = getStatusbarItemsForContainer(otherContainer);
                        const lastStatusItem = statusbarItems[statusbarItems.length - 1];

                        if (lastStatusItem) {
                          lastStatusItem.focus();
                          return;
                        }
                      }
                      // Non-sequential or fallback: focus the other editor
                      const editorId = otherContainer.getAttribute('data-texteditor-editor-id');
                      if (editorId && window.tinymce) {
                        const otherEditor = window.tinymce.get(editorId);
                        if (otherEditor) {
                          otherEditor.focus();
                          return;
                        }
                      }
                    }
                    // If the previous element is not related to another TextEditor, focus the previous element
                    target.focus();
                  }
                };

                const focusNextElement = () => {
                  const container = editor.getContainer();

                  // Get all focusable elements on the page
                  const allFocusables = Array.from(getAllFocusableElements());

                  // Find the first focusable element after the editor container
                  const nextElement = allFocusables.find(el =>
                    !container.contains(el) && (container.compareDocumentPosition(el) & Node.DOCUMENT_POSITION_FOLLOWING)
                  );

                  if (nextElement) {
                    // Reset flag as we are leaving editors internal navigation
                    editor._isNavigatingInternal = false;

                    // Check if the next element is related to another texteditor
                    // or is a textarea of another editor
                    const otherContainer = resolveEditorContainerForElement(nextElement, container);
                    // If the next element is related to another TextEditor,
                    if (otherContainer && otherContainer !== container) {
                      const seqEnabled = otherContainer.getAttribute('data-texteditor-sequential-focus') === 'true';
                      // Sequential focus: focus first menubar button when coming from above
                      if (seqEnabled) {
                        const firstMenubarBtn = otherContainer.querySelector('.tox-mbtn');
                        if (firstMenubarBtn) {
                          firstMenubarBtn.focus();
                          return;
                        }
                      }
                      // Non-sequential or fallback: focus the other editor
                      const editorId = otherContainer.getAttribute('data-texteditor-editor-id');
                      if (editorId && window.tinymce) {
                        const otherEditor = window.tinymce.get(editorId);
                        if (otherEditor) {
                          otherEditor.focus();
                          return;
                        }
                      }
                    }
                    // If the next element is not related to another TextEditor, focus the next element
                    nextElement.focus();
                  }
                };

                // Monitor the page focus to Tab flow direction identification
                document?.addEventListener('focusin', (e) => {
                  if (!sequentialFocusEnabled) return;

                  const container = editor.getContainer();

                  if (container && !container.contains(e.target)) {
                    // Store the ID or a reference of the last element focused OUTSIDE the editor
                    container.setAttribute('data-last-external-element', ''); 
                    editor._lastExternalNode = e.target; 
                  }
                }, true);

                //Fixed Line break for spacebar and multiple mathequations
                editor.on("BeforeSetContent", function (event) {
                  let content = event.content;
                  content = content.replace(/<span>(?:&nbsp;\s*)+<math/g, "<span><math");
                  content = content.replace(/<\/math><\/p>\s*<p><math/g, `</math></p><br/><p><math`);
                  content = content.replace(/<\/math><\/span><span><span>​<\/span><\/span><\/p>\n<p><math/g, '</math></span><br/><\/p>\n<p><math');
                  content = content.replace(/<\/math><\/span><span><\/span><\/p>\s*<p><math/g, '</math></span><br/></p><p><math');   
                  event.content = content
                });

                editor.on('keydown', (e) => {
                  // Shift+Tab on Editor
                  if (e.key === 'Tab' && e.shiftKey && sequentialFocusEnabled) {
                    const lastBtn = getLastToolbarOrMenubarFocusable();
                    e.preventDefault();
                    if (lastBtn) {
                      // Move focus back to last focusable button on toolbar/menubar
                      lastBtn.focus();
                    } else {
                      // Move focus back to previous element
                      focusPreviousElement();
                    }
                  // Tab on Editor
                  } else if (e.key === 'Tab' && !e.shiftKey && sequentialFocusEnabled) {
                    const firstStatusItem = getStatusbarItemsForContainer(editor.getContainer())[0];
                    e.preventDefault();
                    if (firstStatusItem) {
                      // Move focus to first Statusbar item
                      firstStatusItem.focus();
                    } else {
                      // Move focus to next outside element when there is no focusables
                      focusNextElement();
                    }
                  }
                });

                //Add a focus event listener to the editor content area and blur event for when the focus is moved to any of the editors UI components
                editor
                  .on("focus", function () {
                    const container = editor.getContainer();
                    // Saved last focused external element
                    const prevNode = editor._lastExternalNode;
                    let isComingFromAbove = true; // Defualt behavior
                    let isComingFromBelow = false;

                    if (!editor._isNavigatingInternal && sequentialFocusEnabled) {
                      if (prevNode && prevNode.isConnected) {
                        isComingFromAbove = prevNode.compareDocumentPosition(container) & Node.DOCUMENT_POSITION_FOLLOWING;
                        isComingFromBelow = container.compareDocumentPosition(prevNode) & Node.DOCUMENT_POSITION_FOLLOWING;
                      }

                      if (isComingFromAbove) { // Focus Menubar when coming from above
                        const firstMenubarBtn = container.querySelector('.tox-mbtn');
                        if (firstMenubarBtn) {
                          editor._isNavigatingInternal = true;
                          firstMenubarBtn.focus();
                        }
                      } else if (isComingFromBelow) { // Focus Statusbar when coming from below
                        const statusbar = container.querySelector('.tox-statusbar');
                        if (statusbar) {
                          // Query all focusable items in the status bar
                          const statusItems = getStatusbarItemsForContainer(editor.getContainer());
                          // Select the last focusable item
                          const lastStatusBarElement = statusItems[statusItems.length - 1];
                          
                          if (lastStatusBarElement) {
                            editor._isNavigatingInternal = true;
                            lastStatusBarElement.focus();
                          }
                        }
                      }
                    }

                    if (
                      getStringFromHtmlContent(that.props.placeholderText) !==
                        null &&
                      that.state.isClearPlaceholder &&
                      getStringFromHtmlContent(that.props.placeholderText) ===
                        getStringFromHtmlContent(editor.getContent())
                    ) {
                      editor.setContent("", editorConfig);
                      that.setState({ isClearPlaceholder: false });
                    }
                  })
                  .on("blur", function () {
                    if (
                      that.props.placeholderText !== null &&
                      !that.state.isClearPlaceholder &&
                      getStringFromHtmlContent(editor.getContent()) === ""
                    ) {
                      editor.setContent(
                        that.props.placeholderText,
                        editorConfig
                      );
                      that.setState({ isClearPlaceholder: true });
                    }
                    
                    editor._isNavigatingInternal = false;
                  });

                // A polite alert instructs assistive to wait and announce the information
                // when there is a natural pause, such as when the user stops typing. (Word count)
                editor.on("init", function (event) {
                  const container = editor.getContainer();
                  const statusbar = container.querySelector('.tox-statusbar');
                  let tabindexObserver = null;
                  // Mark container so other editors can detect sequential-focus
                  // and focus the correct entry point (menubar/statusbar vs editor)
                  container.setAttribute('data-texteditor-sequential-focus', String(sequentialFocusEnabled));
                  container.setAttribute('data-texteditor-editor-id', editor.id);

                  // Override TinyMCE's roving tabindex so every toolbar/menubar item
                  // is reachable with Tab. Only active when sequential focus is enabled.
                  if (sequentialFocusEnabled) {
                    // Force every menubar/toolbar focusable tabindex to 0 on init
                    container.querySelectorAll(TOOLBAR_ITEM_SELECTOR).forEach(btn => {
                      if (btn.getAttribute('tabindex') !== '0') {
                        btn.setAttribute('tabindex', '0');
                      }
                    });

                    // TinyMCE's roving tabindex mechanism sets the active item to 0 and others to -1.
                    // Re-apply tabindex 0 whenever Alloy resets individual items.
                    tabindexObserver = new MutationObserver((mutations) => {
                      mutations.forEach(({ target }) => {
                        if (
                          target.matches(TOOLBAR_ITEM_SELECTOR) &&
                          target.getAttribute('tabindex') !== '0'
                        ) {
                          target.setAttribute('tabindex', '0');
                        }
                      });
                    });
                    tabindexObserver.observe(container, {
                      attributes: true,
                      attributeFilter: ['tabindex'],
                      subtree: true
                    });
                  }

                  // Editor Container keydown handling
                  const handleContainerKeydown = (e) => {
                    if (e.key === 'Tab' && sequentialFocusEnabled) {
                      const allFocusables = getMenuToolbarFocusables();
                      if (allFocusables.length === 0) return;
                      
                      const activeElement = document.activeElement;
                      // Find the currently focused element is inside menubar or toolbar
                      const activeElementIndex = allFocusables.indexOf(activeElement) !== -1
                        ? allFocusables.indexOf(activeElement)
                        : allFocusables.findIndex(el => el.contains(activeElement));
                      if (activeElementIndex === -1) return;
                      
                      // Shift+Tab on first item → move focus to previous outside focusable element
                      if (e.shiftKey && activeElementIndex === 0) {
                        e.preventDefault();
                        e.stopImmediatePropagation();
                        focusPreviousElement();
                      // Tab on last item → move focus to editor content
                      } else if (!e.shiftKey && activeElementIndex === allFocusables.length - 1) {
                        e.preventDefault();
                        e.stopImmediatePropagation();
                        editor._isNavigatingInternal = true;
                        editor.focus();

                      // TinyMCE Alloy intercepts Tab at the container level and moves focus
                      // between focusable *groups*, not individual items. We override this so
                      // every individual item is reachable with Tab.
                      // Shift+Tab → move focus to previous toolbar/menubar item
                      } else if (e.shiftKey) {
                        e.preventDefault();
                        e.stopImmediatePropagation();
                        allFocusables[activeElementIndex - 1].focus();
                      // Tab → move focus to next toolbar/menubar item
                      } else {
                        e.preventDefault();
                        e.stopImmediatePropagation();
                        allFocusables[activeElementIndex + 1].focus();
                      }
                    }
                  };
                  container?.addEventListener('keydown', handleContainerKeydown, true);

                  // Editor Statusbar keydown handling
                  const handleStatusbarKeydown = (e) => {
                    // TinyMCE natively handles Tab between statusbar items (path, word count, etc.)
                    // so we only handle the boundary transitions here.
                    if (e.key === 'Tab' && sequentialFocusEnabled) {
                      // Get all focusable statusbar items and find the currently focused one
                      const focusables = Array.from(
                        getStatusbarItemsForContainer(editor.getContainer())
                      );
                      if (focusables.length === 0) return;

                      const activeElementIndex = focusables.indexOf(document.activeElement);

                      // Shift+Tab on first statusbar item → move focus back to editor content
                      if (e.shiftKey && activeElementIndex === 0) {
                        // stopImmediatePropagation prevents TinyMCE Alloy's capture-phase
                        // keydown handler from intercepting the event and redirecting focus.
                        e.preventDefault();
                        e.stopImmediatePropagation();
                        editor._isNavigatingInternal = true;
                        editor.focus();
                      // Tab on last statusbar item → move focus to next element outside editor
                      } else if (!e.shiftKey && activeElementIndex === focusables.length - 1) {
                        e.preventDefault();
                        e.stopImmediatePropagation();
                        focusNextElement();
                      }
                    }
                  };
                  statusbar?.addEventListener('keydown', handleStatusbarKeydown, true);

                  // Select the button element by its class
                  let wordButtonElement = document.querySelector(
                    ".tox-statusbar__wordcount"
                  );

                  // Check if the button element exists
                  if (wordButtonElement) {
                    // Add the aria-live attribute
                    wordButtonElement.setAttribute("aria-live", "polite");
                  }

                  // Editor instance cleanup
                  editor.on('remove', () => {
                    // Disconnect observer and remove listeners
                    if (tabindexObserver) tabindexObserver.disconnect();
                    container?.removeEventListener('keydown', handleContainerKeydown, true);
                    statusbar?.removeEventListener('keydown', handleStatusbarKeydown, true);
                  });
                });

                //Block unsecured protocol http on link plugin
                editor.on("BeforeSetContent", function (event) {
                  const content = event.content;
                  const httpLinks = content.match(/<a href="http:\/\/[^"]*"/g);
                  const httpBlobImageLinks = content.match(
                    /<img src="blob:http:\/\/[^"]*"/g
                  );
                  const httpImageLinks = content.match(
                    /<img src="http:\/\/[^"]*"/g
                  );
                  const httpVideoLinks = content.match(
                    /<iframe src="http:\/\/[^"]*"/g
                  );

                  if (
                    httpLinks ||
                    httpBlobImageLinks ||
                    httpImageLinks ||
                    httpVideoLinks
                  ) {
                    editor.windowManager.alert(
                      "HTTP links are not allowed. Please use HTTPS links instead."
                    );
                    event.preventDefault();
                  }
                });

                editor.ui.registry.addButton("Math", {
                  text: "Math",
                  tooltip: "Math equation",
                  onAction: function (_) {
                    that.setEditorOpen(true);
                  },
                });

                editor.ui.registry.addButton("Focus", {
                  text: "Focus",
                  tooltip: "Focus editor",
                  onAction: function (_) {
                    that.editor.focus();
                  },
                });

                editor.ui.registry.addButton("Refresh", {
                  icon: "reload",
                  tooltip: "Refresh editor",
                  onAction: function (_) {
                    if (typeof that.props.refreshEditor === "function") {
                      that.props.refreshEditor(editor);
                    }
                  },
                });

                editor.ui.registry.addMenuItem("Math", {
                  text: "Math equation",
                  tooltip: "Math equation",
                  onAction: function () {
                    that.setEditorOpen(true);
                  },
                });

                editor.on("OpenWindow", function (eventDetails) {
                  const dialogTitle = $(".tox-dialog__title").text();

                  if (dialogTitle === "Insert/Edit Image") {
                    $(":button.tox-button[title='Save']").html("Insert"); //Chenge Save lable to Insert
                    $(
                      ".tox-dialog__body-nav-item.tox-tab:contains('General')"
                    ).html("Embed"); //Change General lable to Embed
                    $(".tox-label:contains('Source')").html("Link"); //Change Source lable to Link
                    $(".tox-dialog__body-nav-item.tox-tab:contains('Upload')")
                      .click()
                      .focus();
                  }
                });
              },
              external_plugins: {
                //fullpage: "https://learningapps-ui-ppe.pearsoned.com/b0/dev/webcomponents-shared/latest/tinymce-fullpage/plugin.js",
                mathjax:
                  "https://learningapps-ui.pearson.com/b0/lass-ui-cdn-libs/v1.2.0/tinymce-mathjax/v1.0.7/plugin.js",
              },
              mathjax: {
                lib: "https://learningapps-ui.pearson.com/b0/lass-ui-cdn-libs/v1.2.0/matheditor/js/mathjax.js", //required path to mathjax
                // lib:"https://learningapps-ui-ppe.pearsoned.com/b0/dev/webcomponents-shared/latest/matheditor/mathjax/es5/tex-chtml-full.js",

                configUrl:
                  "https://learningapps-ui.pearson.com/b0/lass-ui-cdn-libs/v1.2.0/tinymce-mathjax/v1.0.7/config.js",
              },
            }}
            onEditorChange={this.handleEditorChange}
            onBeforeSetContent={this.onBeforeSetContent}
          />
        </div>
      </>
    );
  }
}

TextEditor.propTypes = {
  mathEditor: PropTypes.bool,
  initialContent: PropTypes.string,
  tinymceApiKey: PropTypes.string,
  onChange: PropTypes.func,
  toolbar: PropTypes.string,
  menubar: PropTypes.string,
  insertItems: PropTypes.string,
  height: PropTypes.number,
  setEditorInstance: PropTypes.func,
  refreshEditor: PropTypes.func,
  loader: PropTypes.bool,
  contentStyle: PropTypes.string,
  placeholderText: PropTypes.string,
  id: PropTypes.string,
  quickbarsSelectionToolbar: PropTypes.string,
  valid_children: PropTypes.string,
  valid_elements:  PropTypes.string,
  schema:  PropTypes.string,
  tinymce_extended_properties: PropTypes.object,
  disabled: PropTypes.bool,
  extended_valid_elements: PropTypes.string,
  sequentialFocusEnabled: PropTypes.bool
};

TextEditor.defaultProps = {
  id: generateId(),
  mathEditor: true,
  height: 600,
  toolbar:
    "Focus | undo redo | bold italic underline strikethrough | fontselect fontsizeselect formatselect | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist | forecolor backcolor removeformat | pagebreak | charmap emoticons | fullscreen  preview  print | insertfile image media link anchor codesample Math code | ltr rtl",
  menubar: "file edit view insert format tools table help",
  insertItems:
    "image link media inserttable Math codesample | charmap emoticons hr | pagebreak anchor toc | insertdatetime",
  loader: false,
  contentStyle: "",
  valid_children: "",
  valid_elements: "",
  schema: "",
  placeholderText: null,
  quickbarsSelectionToolbar: "bold italic | quicklink h2 h3 blockquote quicktable",
  tinymce_extended_properties: {},
  disabled: false,
  sequentialFocusEnabled: false,
  extended_valid_elements:
    "span[*],line[x1|y1|x2|y2],g[stroke-width|stroke|fill|transform],svg[style|role]" +
    ",div[id|onclick|style|ontouchstart|class|contenteditable|xmlns|mathdata|pmmldata],path[id|d],input[accept|alt|checked|disabled|maxlength|name|readonly|size|src|type|value|onclick|type]" +
    ",audio[id],source[src|type],img[longdesc|usemap|src|border|alt=|title|hspace|vspace|width|height|align|onclick|class|data-mce-resize|data-mce-placeholder|style]" +
    ",mo[stretchy],mspace[width|linebreak],mtd[columnalign],mpadded[width],mfenced[open|close],menclose[notation],em[*],script[*],a[*],li[*],ul[*],link[*],head[*],title[*],i[*]",
};

export default TextEditor;
